import React from 'react'
import PropTypes from 'prop-types'
import { useToastProviderLogic } from './ToastProvider.logic'
import ToastProviderView from './ToastProvider.view'

export {
  useToast,
  addToastOutsideComponent,
  ToastContext,
} from './ToastProvider.logic'

function ToastProvider(props) {
  const logic = useToastProviderLogic(props)
  return <ToastProviderView {...logic} />
}

ToastProvider.propTypes = {
  children: PropTypes.any,
}

export default ToastProvider
